import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from '../../../services/alerts.service';
import { Deuda, DeudaDetalleData, ResultPayData } from '../../interfaces/DeudaDetalle.interfaces';
import { ActivatedRoute, Router } from '@angular/router';
import Stepper from 'bs-stepper';
import { PagosLineaService } from '../../services/pagos-linea.service';
import packageJson from '../../../../../package.json';
import moment from 'moment';

@Component({
  selector: 'app-pagos-linea',
  templateUrl: './pagos-linea.component.html',
  styleUrls: ['./pagos-linea.component.scss'],
  providers: [AlertService]
})
export class PagosLineaComponent implements OnInit, AfterViewInit {
  @ViewChild('stepperFour') stepperFour!: any;
  @ViewChild('stepperTwo') stepperTwo!: any;
  @ViewChild('stepperOne') stepperOne!: any;
  @ViewChild('openMercadoPago') openMercadoPago!: any;
  disabledAcordeonOne: boolean = false;
  disabledAcordeonTwo: boolean = false;
  disabledAcordeonThree: boolean = false;
  disabledAcordeonFour: boolean = true;
  deshabilitarAcordeons: boolean = false;
  typeDocument: any[] = [];
  resultDetalleDuda!: DeudaDetalleData;
  facturaSelected: any[] = [];
  facturasDeuda!: Deuda;
  facturasFromateadas: any[] = [];
  facturasSelectdCompleta: any[] = [];
  selectes: number = 0;
  saldoTotalAcumulado: number = 0;
  saldoTotalSelected: number = 0;
  paymentMethodForm!: FormGroup;
  btnStepOneClick: boolean = false;
  Recaudo: any;
  dataSend: any;
  DataPay: any;
  showOne: boolean = true;
  showCheckOne: boolean = false;
  showCheckTwo: boolean = false;
  showCheckThree: boolean = false;
  showCheckFour: boolean = false;
  preference_id: string = '';
  DataResultMap: ResultPayData = {

    NombreCompleto: '',
    TipoDocumento: '',
    Documento: '',
    Estado: '',
    Fecha: '',
    Referencia: '',
    Valor: 0,
    Descripcion: '',
    Autorizacion: '',
    Recibo: ''
  };
  deudaDetalleForm: FormGroup = this._fb.group({
    ClienteFinanciero: [null],
    LocalCliente: [null],
    FormaDePago: [null],
    SerieId: [null],
    NumeroId: [null],
    ParcelaId: [null],
    SerieAutorizado: [null],
    NumeroAutorizado: [null],
    TipoComprobante: [null],
    Ano: [null],
    Mes: [null],
    Estado: [null],
    DetalleEstado: [null],
    ValorTotal: [null],
    SaldoTotal: [null],
    selected: [null]
  });
  deudaForm: FormGroup = this._fb.group({
    TipoDocumentoRP: [null],
    DocumentoRP: [null],
    NombreRP: [null],
    Deudas: this._fb.array([]),
    Exito: [null],
    Mensaje: [null],
  });
  public get DeudasArray(): FormArray {
    return this.deudaForm.controls['Deudas'] as FormArray;
  }
  flag: string = '';
  flagParam: string = '';
  documento: string = '';
  tipoDoc: number = 0;
  isLoading: boolean = false;
  showTitleSerie: boolean = true;
  enableButtonPay: boolean = false;
  facturas: any;
  urlMercadoPago: any;
  infoPreference: any;
  country: string;
  doc: string;
  resultado: string;
  tipoDocParam: string;
  version: string = '';
  activeModal: boolean = false;
  company: string = '';
  money: string = '';
  constructor(private _pagosLineaService: PagosLineaService, private _fb: FormBuilder, private _alertService: AlertService,
     private _activated: ActivatedRoute,private router: Router,
    private route: ActivatedRoute) {
  }
  
  private stepper: Stepper;

  next() {
    this.stepper.next();
  }

  onSubmit() {
    return false;
  }

  ngOnInit(): void {
    this.version = packageJson.version;
    this.initializateForm();
    this.enableButtonPay = false;
    this.country = this._activated.snapshot.paramMap.get('country');
    this.tipoDocParam = this._activated.snapshot.paramMap.get('type');
    this.doc = this._activated.snapshot.paramMap.get('cc');
    this.resultado = this._activated.snapshot.paramMap.get('resultado');

    if (this.country) {
      this.flag = String(this.country);
      if (this.flag === 'colombia') { this.company = 'Grupo emi'; this.money = 'COP'; } else {this.company = 'UCM'; this.money = 'UYU'};
    }

    if (this.tipoDocParam) {
      switch (this.tipoDocParam) {
        case 'cc':
          this.tipoDocParam = '1';
          break;
        case 'ti':
          this.tipoDocParam = '2';
          break;
        case 'ce':
          this.tipoDocParam = '3';
          break;
        case 'pas':
          this.tipoDocParam = '4';
          break;
        case 'rc':
          this.tipoDocParam = '5';
          break;
        case 'nit':
          this.tipoDocParam = '7';
          break;
        case 'otro':
          this.tipoDocParam = '9';
          break;
        default:
          break;
      }
      this.paymentMethodForm.controls['TipoDocumento'].setValue(+String(this.tipoDocParam));
    }
    if (this.doc) {
      this.paymentMethodForm.controls['Documento'].setValue(String(this.doc));
    }
    if (this.resultado) { this.showCheckThree = true; }

    if (this.flag !== '' && this.flag !== undefined && this.flag !== null) {
      this.getDeudaDetalle();
    }

    this.stepper = new Stepper(document.querySelector('#stepper1'), {
      linear: false,
      animation: true
    });

    this.getTypeDocument();
  }

  ngAfterViewInit(): void {
    let resultado = this._activated.snapshot.paramMap.get('resultado');
    if (resultado) {
      this.showOne = false;
      this.showCheckOne = false;
      this.showCheckTwo = false;
      this.showCheckThree = false;
      this.stepperFour.nativeElement.click();
    }

    this.route.queryParams.subscribe(params => {
      this.preference_id = params['preference_id'];
      if (this.preference_id !== '' && this.preference_id !== null && this.preference_id !== undefined) {
        this.getInfoPreference(this.preference_id);
      }
    });
  }

  getTypeDocument() {
    this.isLoading = true;
    this.typeDocument = [];
    // const ambiente = this.flag === 'colombia' ? 'CoPlsUy' : 'UyPrd';
    const ambiente = this.flag === 'colombia' ? 'col' : 'uy';
    this._pagosLineaService.getTypeDocument(ambiente).subscribe(
      result => {
        this.isLoading = false;
        this.typeDocument = result.data.documentos;
      }
    );
  }

  getDeudaDetalle() {
    if (this.paymentMethodForm.valid) {
      this.DeudasArray.clear();
      this.isLoading = true;
      const dateNow = new Date();
      const dateFormatFinish = moment(dateNow.toISOString()).format('YYYYMMDD').toString();
      const dateInitial = moment(dateNow).add(-2, 'years').toISOString();
      const dateFormatInitial = moment(dateInitial).format('YYYYMMDD').toString();

      this.paymentMethodForm.controls['TipoDocumento'].setValue(String(this.paymentMethodForm.controls['TipoDocumento'].value));
      const objGetDataClient = {
          "TipoDocumento": this.paymentMethodForm.controls['TipoDocumento'].value,
          "Documento": this.paymentMethodForm.controls['Documento'].value,
          "FechaDesde": String(dateFormatInitial),
          "FechaHasta": String(dateFormatFinish)
      }
      const ambiente = this.flag === 'colombia' ? 'col' : 'uy';
      this._pagosLineaService.getDeudaDetalle(objGetDataClient, ambiente).subscribe(
        result => {
          this.isLoading = false;
          this.resultDetalleDuda = result;
          if (this.resultDetalleDuda?.data !== null) {
            if (this.resultDetalleDuda?.data.facturas.length <= 0 && this.resultDetalleDuda?.status == true) {
              if (this.resultDetalleDuda.data.mensaje === '' || this.resultDetalleDuda.data.mensaje === null ) {
                this._alertService.WarniginBig('El cliente no tiene facturas pendientes.');
              } else {
              this._alertService.WarniginBig(this.resultDetalleDuda.data.mensaje);
              }
            } else if (this.resultDetalleDuda.data.facturas.length <= 0 && !this.resultDetalleDuda?.status == false) {
              if (this.resultDetalleDuda.data.mensaje === '' || this.resultDetalleDuda.data.mensaje === null ) {
                this._alertService.WarniginBig('El cliente no tiene facturas pendientes.');
              } else {
              this._alertService.WarniginBig(this.resultDetalleDuda.data.mensaje);
              }
            } else {
             const resultDeudas = this.resultDetalleDuda.data.facturas.filter(c => c.saldoFactura > 0 )
                if (resultDeudas.length > 0) {
                  this.MapearDeudas();
                  this.disabledAcordeonOne = true;
                  this.showCheckOne = true;
                  this.next();
                } else {
                  this._alertService.WarniginBig('El cliente no tiene facturas pendientes.');
                }
            }
          } else {
            this._alertService.WarniginBig(this.resultDetalleDuda?.message);
          }
        }, error => {
          this.isLoading = false;
        }
      );
    } else {
      this.paymentMethodForm.markAllAsTouched();
    }
  }

  private MapearDeudas() {

    this.deudaForm.controls['TipoDocumentoRP'].setValue(this.resultDetalleDuda.data.tipoDocumento);
    this.deudaForm.controls['DocumentoRP'].setValue(this.resultDetalleDuda.data.documento);
    this.deudaForm.controls['NombreRP'].setValue(this.resultDetalleDuda.data.nombre);
    this.resultDetalleDuda.data.facturas.forEach((detalle: Deuda) => {
      if (detalle.saldoFactura > 0 ) {
          const dateFormat = detalle.fechaVencimiento.toString().substring(6,4) + '/'+ detalle.fechaVencimiento.toString().substring(0,4);
          this.deudaDetalleForm = this._fb.group({
            consumidorFinal: [detalle.consumidorFinal],
            descripcionFactura: [dateFormat],
            estado:[detalle.estado],
            fechaEmision: [detalle.fechaEmision],
            fechaVencimiento: [detalle.fechaVencimiento],
            importe: [detalle.importe],
            moneda: [detalle.moneda],
            montoGravado: [detalle.montoGravado],
            numero: [detalle.numero],
            numeroInterno: [detalle.numeroInterno],
            saldoFactura: [detalle.saldoFactura],
            serie: [detalle.serie],
            serieInterna: [detalle.serieInterna],
            tipoComprobante: [detalle.tipoComprobante],
            selected: false,
          });
          this.saldoTotalAcumulado = this.saldoTotalAcumulado + detalle.saldoFactura;
          this.DeudasArray.push(this.deudaDetalleForm);
        }
    });
    this.deudaForm.controls['Exito'].setValue(this.resultDetalleDuda.data.exito);
    this.deudaForm.controls['Mensaje'].setValue(this.resultDetalleDuda.data.mensaje);
  }

  getFormDeuda(deuda: AbstractControl): FormGroup {
    return deuda as FormGroup;
  }

  changeSelected() {
    this.facturaSelected = this.DeudasArray.value.filter((c: any) => c.selected === true);
    if (this.facturaSelected.length !== this.selectes) {
      this.disabledAcordeonTwo = false;
      this.disabledAcordeonThree = false;
    }
  }

  receiptsSelected() {
    this.isLoading = true;
    this.facturasSelectdCompleta = [];
    this.facturasFromateadas = [];
    this.saldoTotalSelected = 0;
    this.selectes = 0;
    this.facturaSelected = this.DeudasArray.value.filter((c: any) => c.selected === true);
    this.facturaSelected.forEach((detalle: any) => {
      this.saldoTotalSelected = this.saldoTotalSelected + detalle.saldoFactura;
    });
    if (this.facturaSelected.length === this.DeudasArray.length) {
      this.NextDeudaSelect();
    } else {
      if (this.facturaSelected.length === 0) {
        this.NextDeudaSelect();
      } else {
        this.facturaSelected.forEach(select => {

          this.DeudasArray.value.forEach((deuda: any) => {
            const fechaDeudaFormat  = (select.fechaVencimiento.toString().substring(0,4) + '/' + select.fechaVencimiento.toString().substring(6,4));
            const fechaDeuda = new Date(fechaDeudaFormat);
            const fechaSelectFormat =  (deuda.fechaVencimiento.toString().substring(0,4) + '/' + deuda.fechaVencimiento.toString().substring(6,4));
            const fechaSelect = new Date(fechaSelectFormat);
            if ((fechaDeuda  > fechaSelect) && !deuda.selected) {
              this.btnStepOneClick = false;
              this.isLoading = false;
              this._alertService.WarniginBigConfirmation('Debe seleccionar las facturas mas antiguas.').then((result: any) => {
                if (result) {
                  this.showCheckTwo = false;
                  this.showCheckThree = false;
                  this.stepperTwo.nativeElement.click();
                  this.facturaSelected = [];
                }
              });
            } else {
              this.NextDeudaSelect();
            }
          });
        });
      }
    }
  }

  NextDeudaSelect() {
    this.selectes = this.facturaSelected.length;
    if (this.facturaSelected.length <= 0) {
      this.btnStepOneClick = false;
      this.isLoading = false;
      this._alertService.WarniginBig('Debe seleccionar una factura');
    } else {
      this.next();
      this.showCheckTwo = true;
      this.isLoading = false;
    }
  }

  PagarMercadoPago() {
    this.enableButtonPay = true;
    this.isLoading = true;
    if (this.flag === 'colombia') {
      this.showTitleSerie = true;
    } else {
      this.showTitleSerie = false;
    }

    this.ImportarRecaudo();
  }

  ImportarRecaudo() {
    this.facturasSelectdCompleta = [];
    this.facturasFromateadas = [];
    this.facturaSelected.forEach(select => {
      const date = select.descripcionFactura.split('/');
           
      const selectOldFormat = {
        ano: date[1],
        clienteFinanciero: this.resultDetalleDuda.data.documento,
        detalleEstado: select.estado,
        estado: select.estado,
        formaDePago: "TC",
        localCliente: "01",
        mes:  date[0],
        numeroAutorizado: select.numero,
        numeroId: select.numeroInterno,
        parcelaId: "",
        saldoTotal:  Math.round(select.saldoFactura),
        serieAutorizado: select.serie,
        serieId: select.serieInterna,
        tipoComprobante: select.tipoComprobante,
        valorTotal: Math.round(select.saldoFactura)
      }
      this.facturasFromateadas.push(selectOldFormat);
    });
   

    this.dataSend = {
      "tipoDocumentoRP": this.resultDetalleDuda.data.tipoDocumento,
      "documentoRP": this.resultDetalleDuda.data.documento,
      "nombreRP": this.resultDetalleDuda.data.nombre,
      "deudas": this.facturasFromateadas,
      "exito": 1,
      "mensaje": null
    }

    const ambiente = this.flag === 'colombia' ? 'col' : 'uy';
    this._pagosLineaService.Pagar(this.dataSend, ambiente).subscribe(
      result => {
        if (result.status) {
           
          this.urlMercadoPago = result.data.initPoint;

          this.facturaSelected.forEach((itemSelect: any) => {
            this.saldoTotalSelected = this.saldoTotalSelected + itemSelect.SaldoTotal;
            this.facturasDeuda = itemSelect;
            this.facturasDeuda.serie = itemSelect.SerieAutorizado;
            this.facturasSelectdCompleta.push(this.facturasDeuda);
          });
          this.isLoading = false;
          window.location.href = this.urlMercadoPago;
 
        } else {
          this.isLoading = false;
          this.enableButtonPay = false;
          this._alertService.WarniginBig(result.message);
        }
      }, error => {
        this.enableButtonPay = false;
        this.isLoading = false;
        this._alertService.WarniginBigReload(error.message, this.flag);
      }
    );
  }

  resetFormData() {
    this.DeudasArray.reset();
    this.facturasSelectdCompleta = [];
    this.DataResultMap = {
      NombreCompleto: '',
      TipoDocumento: '',
      Documento: '',
      Estado: '',
      Fecha: '',
      Referencia: '',
      Valor: 0,
      Descripcion: '',
      Autorizacion: '',
      Recibo: ''
    };
    this.disabledAcordeonOne = false;
    this.disabledAcordeonTwo = false;
    this.disabledAcordeonThree = false;
  }

  resetStepperOne() {
    this.showCheckOne = false;
    this.showCheckTwo = false;
    this.showCheckThree = false;
    this.showCheckFour = false;
    this.saldoTotalAcumulado = 0;
  }

  resetStepperTwo() {
    this.showCheckTwo = false;
  }

  resetStepperThree() {
    this.showCheckThree = false;
  }

  resetStepperFour() {
    this.showCheckFour = false;
  }

  getInfoPreference(id: string) {
    const ambiente = this.country === 'colombia' ? 'col' : 'uy';
    this._pagosLineaService.getInfoPreference(id, ambiente).subscribe(
      result => {
        this.infoPreference = result.data;
      }
    )
  }

  PrintVoucher() {
    window.print();
  }

  gotToHome() {
    const url = document.location.href.split('true');
    var result = url[0];
    document.location.href = result;
  }

  initializateForm() {
    this.paymentMethodForm = this._fb.group({
      TipoDocumento: [null, [Validators.required]],
      Documento: [null, [Validators.required, Validators.pattern('[0-9]{1,20}')]]
    });
  }

}